import React, { useEffect, useState } from 'react';
import { apiFetch, parseJsonSafe } from '../utils/api';
import Select from 'react-select';

const moduleOptions = [
  { value: 'clientes', label: 'Clientes' },
  { value: 'comunicaciones', label: 'Comunicaciones' },
  { value: 'captacion', label: 'Captación' },
  { value: 'captacion_business', label: 'Captación Business' },
  { value: 'captacion_borme', label: 'Captación Borme' },
  { value: 'google_ads', label: 'Leads webhook' },
  { value: 'google_api', label: 'Conexiones Google (Ads, Merchant y GA4)' },
  { value: 'services', label: 'Servicios' },
  { value: 'facturas', label: 'Facturas' },
  { value: 'presupuestos', label: 'Presupuestos' },
  { value: 'dominios', label: 'Dominios' },
  { value: 'hosting', label: 'Hosting' },
  { value: 'agenda', label: 'Agenda' },
  { value: 'tareas', label: 'Tareas' },
  { value: 'jornada', label: 'Jornada laboral' },
  { value: 'proyectos', label: 'Proyectos' },
  { value: 'social', label: 'Social' },
  { value: 'email_marketing', label: 'Email marketing' },
  { value: 'galeria', label: 'Galería' },
  { value: 'whatsapp', label: 'Whatsapp' },
  { value: 'software', label: 'Software / Licencias' },
  { value: 'monitorizacion', label: 'Monitorización' },
  { value: 'agentes', label: 'Agentes IA' },
  { value: 'usuarios', label: 'Usuarios' },
  { value: 'configuracion', label: 'Configuración' }
];

const UsersPage = () => {
  const token = localStorage.getItem('token');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', password: '', permissions: 'todo', modules: [], dolibarr_user_id: null });
  const [dolibarrUsers, setDolibarrUsers] = useState([]);

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/login';
  };

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch('/api/users', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error cargando usuarios');
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchDolibarrUsers = async () => {
    try {
      const res = await apiFetch('/api/users/dolibarr', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok && Array.isArray(data)) setDolibarrUsers(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchDolibarrUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitUser = async (e) => {
    e.preventDefault();
    setError('');
    const isEdit = Boolean(editing);
    const path = isEdit ? `/api/users/${editing}` : '/api/users';
    const method = isEdit ? 'PUT' : 'POST';
    const payload = { ...form };
    if (!payload.password) delete payload.password;
    try {
      const res = await apiFetch(path, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error guardando usuario');
      setForm({ name: '', email: '', password: '', permissions: 'todo', modules: [], dolibarr_user_id: null });
      setEditing(null);
      fetchUsers();
    } catch (err) {
      setError(err.message);
    }
  };

  const editUser = (u) => {
    setEditing(u.id);
    setForm({
      name: u.name || '',
      email: u.email,
      password: '',
      permissions: u.permissions === 'social' ? 'restringido' : (u.permissions || 'todo'),
      modules: Array.isArray(u.modules) ? u.modules : [],
      dolibarr_user_id: u.dolibarr_user_id || null
    });
  };

  const deleteUser = async (id) => {
    if (!window.confirm('¿Eliminar este usuario?')) return;
    try {
      const res = await apiFetch(`/api/users/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error eliminando usuario');
      fetchUsers();
    } catch (err) {
      alert(err.message);
    }
  };

  const renderPermissionLabel = (p) => (p === 'restringido' || p === 'social' ? 'Restringido' : 'Todo');

  return (
    <div className="small">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Usuarios</h2>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="row g-3">
        <div className="col-12 col-lg-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5>{editing ? 'Editar usuario' : 'Crear usuario'}</h5>
              <form className="row g-2" onSubmit={submitUser}>
                <div className="col-12">
                  <label className="form-label">Nombre</label>
                  <input className="form-control" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} />
                </div>
                <div className="col-12">
                  <label className="form-label">Email *</label>
                  <input className="form-control" type="email" required value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} />
                </div>
                <div className="col-12">
                  <label className="form-label">{editing ? 'Contraseña (opcional para cambiar)' : 'Contraseña *'}</label>
                  <input className="form-control" type="password" required={!editing} value={form.password} onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} />
                </div>
                <div className="col-12">
                  <label className="form-label">Permisos</label>
                  <select className="form-select" value={form.permissions} onChange={(e) => setForm((p) => ({ ...p, permissions: e.target.value }))}>
                    <option value="todo">Todo</option>
                    <option value="restringido">Restringido</option>
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label">Acceso a módulos (dejar vacío para todos)</label>
                  <Select
                    isMulti
                    options={moduleOptions}
                    value={moduleOptions.filter((o) => form.modules?.includes(o.value))}
                    onChange={(opts) => setForm((p) => ({ ...p, modules: opts ? opts.map((o) => o.value) : [] }))}
                    placeholder="Selecciona módulos"
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Usuario Dolibarr</label>
                  <Select
                    classNamePrefix="select"
                    isClearable
                    placeholder="Seleccione usuario de Dolibarr"
                    options={dolibarrUsers.map((u) => ({ value: u.id, label: `${u.firstname || ''} ${u.lastname || ''}`.trim() || u.login || u.email || u.id }))}
                    value={dolibarrUsers.map((u) => ({ value: u.id, label: `${u.firstname || ''} ${u.lastname || ''}`.trim() || u.login || u.email || u.id })).find((o) => o.value === form.dolibarr_user_id) || null}
                    onChange={(opt) => setForm((p) => ({ ...p, dolibarr_user_id: opt ? opt.value : null }))}
                  />
                </div>
                <div className="col-12 d-flex gap-2">
                  <button className="btn btn-primary" type="submit">Guardar</button>
                  {editing && <button type="button" className="btn btn-outline-secondary" onClick={() => { setEditing(null); setForm({ name: '', email: '', password: '', permissions: 'todo', modules: [], dolibarr_user_id: null }); }}>Cancelar</button>}
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-8">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5>Lista de usuarios</h5>
              {loading ? (
                <p>Cargando...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm align-middle">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th>Permisos</th>
                        <th>Módulos</th>
                        <th>Creado</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.length ? users.map((u) => (
                        <tr key={u.id}>
                          <td>{u.name || '-'}</td>
                          <td>{u.email}</td>
                          <td>{renderPermissionLabel(u.permissions)}</td>
                          <td className="small">
                            {Array.isArray(u.modules) && u.modules.length
                              ? u.modules.map((m) => moduleOptions.find((o) => o.value === m)?.label || m).join(', ')
                              : 'Todos'}
                          </td>
                          <td>{u.created_at ? new Date(u.created_at).toLocaleDateString() : '-'}</td>
                          <td className="text-end">
                            <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => editUser(u)}>Editar</button>
                            <button className="btn btn-sm btn-outline-danger" onClick={() => deleteUser(u.id)}>Eliminar</button>
                          </td>
                        </tr>
                      )) : (
                        <tr><td colSpan="6">Sin usuarios.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersPage;
